/*       */

import { loadData, mutateData } from 'app/utils/redux/action-utils';
import OptionsBuilder from 'app/utils/api/OptionsBuilder';
import { getAvatar } from 'app/utils/avatar/avatar';
import isUuid from 'uuid-validate';

import designerHookActionsListQuery from 'graphql/designer/designerHookActionsListQuery';
import designerHookActionQuery from 'graphql/designer/designerHookActionQuery';
import updateHookActionMutation from 'graphql/designer/updateHookActionMutation';
import publishHookActionMutation from 'graphql/designer/publishHookActionMutation';
import createHookActionMutation from 'graphql/designer/createHookActionMutation';


import loadScriptsTypeaheadQuery from 'graphql/designer/loadScriptsTypeaheadQuery';
import loadAvatarQuery from 'graphql/designer/loadAvatarQuery';

export const LOAD_HOOK_ACTIONS_STARTED = '@@affectli/designer/LOAD_HOOK_ACTIONS_STARTED';
export const LOAD_HOOK_ACTIONS = '@@affectli/designer/LOAD_HOOK_ACTIONS';

export const LOAD_HOOK_ACTION_STARTED = '@@affectli/designer/LOAD_HOOK_ACTION_STARTED';
export const LOAD_HOOK_ACTION = '@@affectli/designer/LOAD_HOOK_ACTION';

export const CREATE_HOOK_ACTION_STARTED = '@@affectli/designer/CREATE_HOOK_ACTION_STARTED';
export const CREATE_HOOK_ACTION = '@@affectli/designer/CREATE_HOOK_ACTION';

export const UPDATE_HOOK_ACTION_STARTED = '@@affectli/designer/UPDATE_HOOK_ACTION_STARTED';
export const UPDATE_HOOK_ACTION = '@@affectli/designer/UPDATE_HOOK_ACTION';

export const LOAD_HOOK_ACTIONS_TYPEAHEAD_STARTED = '@@affectli/designer/LOAD_HOOK_ACTIONS_TYPEAHEAD_STARTED';
export const LOAD_HOOK_ACTIONS_TYPEAHEAD = '@@affectli/designer/LOAD_HOOK_ACTIONS_TYPEAHEAD';

export const LOAD_AVATAR_STARTED = '@@affectli/designer/hookActions/LOAD_AVATAR_STARTED';
export const LOAD_AVATAR = '@@affectli/designer/hookActions/LOAD_AVATAR';

export const loadAvatar = id => (dispatch, getState) => {
    const avatar = getAvatar(getState(), 'hookAction', id);
    if (avatar && (avatar.isLoading || avatar.loadedAt > Date.now() - 60 * 60 * 1000)) {
        // if we are loding the avatar or it is already loaded and it is stored less then 1 hour ago
        // we return the data in the state without calling the service
        return Promise.resolve(avatar);
    }
    if (!isUuid(id)) {
        return Promise.resolve(null);
    }
    return loadData(LOAD_AVATAR_STARTED, LOAD_AVATAR, loadAvatarQuery)({ id })(dispatch, getState);
};

/**
 * Loads the hookActions
 */
export const loadHookActions = (options = {}) => {
    const variables = new OptionsBuilder(options).defaultStartStopIndexs(0, 30).build();

    return loadData(LOAD_HOOK_ACTIONS_STARTED, LOAD_HOOK_ACTIONS, designerHookActionsListQuery)({ ...variables, startIndex: options.startIndex });
};

/**
 * Loads the hookAction with the given id
 */
export const loadHookAction = id => loadData(LOAD_HOOK_ACTION_STARTED, LOAD_HOOK_ACTION, designerHookActionQuery)({ id });

/**
 * Creates a new the hookAction
 */
export const createHookAction = record => mutateData(CREATE_HOOK_ACTION_STARTED, CREATE_HOOK_ACTION, createHookActionMutation, 'HookAction created successfully.')({ record: {
    ...record,
    type: 'system_hook_action'
}});

/**
 * Updates a hookAction
 */
export const updateHookAction = (record, disableMessage) => (dispatch, getState) => {
    return mutateData(UPDATE_HOOK_ACTION_STARTED, UPDATE_HOOK_ACTION, updateHookActionMutation, !disableMessage ? 'HookAction updated successfully.' : null)({ record: {
        ...record,
        type: 'system_hook_action'
    }})(
        dispatch,
        getState
    );
};

/**
 * Published a hookAction
 */
export const publishHookAction = id => mutateData(UPDATE_HOOK_ACTION_STARTED, UPDATE_HOOK_ACTION, publishHookActionMutation, 'HookAction published successfully.')({ id });

export const loadHookActionsTypeahead = options => {
    const variables = new OptionsBuilder(options).filter({ field: 'lastVersion.id', op: 'is not null' }).build();
    return loadData(LOAD_HOOK_ACTIONS_TYPEAHEAD_STARTED, LOAD_HOOK_ACTIONS_TYPEAHEAD, loadScriptsTypeaheadQuery)(variables);
};
